const BACK = 'shift+esc';

const btnKeyMap = {
    shiftEsc: {
        sequence: BACK,
        action: 'keydown',
    }
};

export {
    BACK,
    btnKeyMap,
};